import { render, staticRenderFns } from "./CollabTopBar.vue?vue&type=template&id=3f0d6fea&"
import script from "./CollabTopBar.vue?vue&type=script&lang=js&"
export * from "./CollabTopBar.vue?vue&type=script&lang=js&"
import style0 from "./CollabTopBar.vue?vue&type=style&index=0&id=3f0d6fea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VImg,VSpacer})
